<ion-app>
  <ion-router-outlet />
  <feature-cookies-overlay />
</ion-app>
